"use client";

import React from "react";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { cn } from "utils";
import { EdgenModalCreateAble } from "@/src/components/EdgenModal";

export interface MobileDetailModalProps {
  onClose: () => void;
  className?: string;
  headerOtherContent?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * @description 统一的资产洞察弹窗骨架，支持根据 viewName 展示不同内容。
 */
const MobileDetailModal: React.FC<MobileDetailModalProps> = ({
  onClose,
  className,
  headerOtherContent,
  children,
}) => {
  return (
    <div
      className={cn("h-full bg-background_solid_neutral_secondary", className)}
    >
      <div className="flex items-center justify-between gap-2 py-3">
        <Icon
          data-openreplay-label="left-arrow-alt"
          className="shrink-0"
          name="left-arrow-alt"
          size={24}
          color={ospThemes.colors.content_primary}
          onClick={onClose}
        />
        {headerOtherContent}
      </div>
      {children}
    </div>
  );
};

export const openMobileDetailModal = async (
  props: Omit<MobileDetailModalProps, "onClose"> = {},
) => {
  const { ...otherProps } = props;
  return new Promise<typeof EdgenModalCreateAble>((resolve) => {
    EdgenModalCreateAble.call({
      children: (
        <MobileDetailModal
          onClose={() => {
            EdgenModalCreateAble.end(false);
          }}
          {...otherProps}
        />
      ),
      wrapperStyle: {
        transition: "none",
        height: "100dvh",
      },
      contentStyle: {
        borderRadius: 0,
        backgroundColor: ospThemes.colors.background_solid_secondary,
        width: "100%",
        padding: 0,
        height: "100dvh",
      },
      containerStyle: {
        height: "100%",
      },
      titleStyle: {
        minHeight: 0,
      },
      showClose: false,
      destroyOnClose: true,
    });
    resolve(EdgenModalCreateAble);
  });
};
